import React from "react"

/**
 * given a teaser (with all its data) returns
 * further statistics. Those are retrieved by model type or view widget
 * @param {import('..').CommonTeaserProps} item
 */
export default function additionalTeaserStats(item) {
  let stats = []
  if (item.social_buttons && item.social_buttons.length > 0) {
    const { count, downs, ups } = item.AGG_LIKE || {
      count: 0,
      ups: 0,
      downs: 0,
    }
    const { count: commentCount } = item.AGG_COMMENT || { count: 0 }

    stats = [
      ...stats,
      ...item.social_buttons.reduce((list, s) => {
        const fake = { name: "like_fake", title: "Fake", value: s.fakeCount }
        switch (s.type) {
          case "COMMENT":
            return [
              ...list,
              {
                name: "comment_count",
                title: "Kommentare",
                value: commentCount,
              },
            ]
          case "UPDOWNVOTE":
            return [
              ...list,
              { name: "like_downs", title: "Pfuii", value: downs },
              { name: "like_ups", title: "Huii", value: ups },
              fake,
            ]
          case "LIKE":
            return [
              ...list,
              { name: "like_count", title: "Likes", value: count },
              fake,
            ]
          default:
            return list
        }
      }, []),
    ]
  }

  return stats
}
